import React, { useState } from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import { getQueryParams } from "@/utils/filters";
import { isUserPCP } from "@/redux/actions/auth";
import { useCareTeam } from "@/utils/hooks/useCarePlan";

import { A5AssessmentCard } from "../CarePlan/A5AssessmentCard/A5AssessmentCard";
import CareGoalsCard from "../CarePlan/CareGoalsCard/CareGoalsCard";
import CarePlanCard from "../CarePlanCard";
import { CarePlanScreenings } from "../CarePlan/CarePlanScreenings";
import CareTeamCard, { checkIfProviderOnCareTeam } from "../CarePlan/CareTeamCard/CareTeamCard";
import DemographicsCard from "../DemographicCard";
import { PatientGoalsStrengthsCautions } from "../CarePlan/PatientGoalsStrengthsCautions/PatientGoalsStrengthsCautions";

import CarePlanCreation from "./CarePlanCreation";
import "./style.scss";

const MemberProfileCarePlan = (props) => {
  const openLegacyGoals = getQueryParams("openLegacyGoals", props.location.search);

  const profile = useSelector((state) => state.auth.profile);

  const patientDetails = props.patientDetails;

  const [showCarePlanPopup, setShowCarePlanPopup] = useState(openLegacyGoals || false);
  const { careTeamMembers, refreshCareTeam } =
    useCareTeam(props.match.params.patientId, props.data.careTeam, { show_history: true }) ?? [];

  const isProviderOnCareTeam = checkIfProviderOnCareTeam(profile, careTeamMembers);

  return (
    <>
      {showCarePlanPopup && (
        <CarePlanCreation
          close={() => {
            const searchParams = new URLSearchParams(props.location.search);

            searchParams.delete("openLegacyGoals");
            props.history.push({
              pathname: location.pathname,
              search: searchParams.toString(),
            });

            setShowCarePlanPopup(false);
          }}
          isPatientInactive={patientDetails["status"] === "INACTIVE"}
          patientId={props.match.params.patientId}
        />
      )}

      <div className="MemberProfileCarePlan--container">
        <DemographicsCard
          demographics={{
            ...props.carePlan?.demographics,
            pcp_location: patientDetails?.pcp_location,
            pcp_name: patientDetails?.pcp_name,
          }}
          patientId={props.match.params.patientId}
        />

        <CareTeamCard
          careTeamMembers={careTeamMembers}
          patientId={props.match.params.patientId}
          refreshCareTeam={refreshCareTeam}
        />

        {/* Care plan doesn't exist for unregistered patients, which these components require */}
        {props.carePlan?.care_plan_id && (
          <>
            <CareGoalsCard
              careTeamMembers={careTeamMembers}
              isProviderOnCareTeam={isProviderOnCareTeam}
              patientDetails={props.patientDetails}
              patientId={props.match.params.patientId}
              refreshCareTeam={refreshCareTeam}
            />

            <PatientGoalsStrengthsCautions
              isProviderOnCareTeam={isProviderOnCareTeam}
              patientId={props.match.params.patientId}
            />
          </>
        )}

        {!isUserPCP() && (
          <A5AssessmentCard assessmentSummaries={props.carePlan?.assessment_summaries} />
        )}

        <CarePlanScreenings
          gadSummary={props.carePlan?.assessment_summaries?.gad}
          phqSummary={props.carePlan?.assessment_summaries?.phq}
        />

        <CarePlanCard
          patientId={props.match.params.patientId}
          showCard={() => setShowCarePlanPopup(true)}
        />
      </div>
    </>
  );
};

export default withRouter(MemberProfileCarePlan);
